import styled from "styled-components";

const h1 = styled.h1`
  color: #828596;
  text-transform: uppercase;
  font-size: 24px;
  line-height: 26px;
  i {
    font-style: italic;
  }
  b,
  strong {
    font-weight: bold;
  }
`;

const h2 = styled.h2`
  color: #828596;
  font-size: 22px;
  line-height: 24px;
  text-transform: uppercase;
  b,
  strong {
    color: #828596;
    font-weight: bold;
  }
`;

const h3 = styled.h3`
  color: #828596;
  font-size: 20px;
  line-height: 21px;
  b,
  strong {
    font-weight: bold;
  }
`;

const h4 = styled.h4`
  color: #000;
  font-size: 18px;
  line-height: 20px;
  margin: 0;
  b,
  strong {
    font-weight: bold;
  }
`;

const h5 = styled.h5`
  color: #828596;
  font-size: 16px;
  line-height: 18px;
  b,
  strong {
    font-weight: bold;
  }
`;

const h6 = styled.h6`
  color: #828596;
  font-size: 10px;
  line-height: 12px;
  i {
    font-style: italic;
  }
  b,
  strong {
    font-weight: bold;
  }
`;

const p = styled.p`
  color: #828596;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.3px;
  font-family: "Open Sans";
  i {
    font-style: italic;
  }
  b,
  strong {
    font-weight: bold;
  }
  em {
    font-weight: bold;
    text-transform: uppercase;
  }
`;

const Type = {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
};

export default Type;

/*
Doc
import Type from './Global/Typography.js';

H1
<Type.h1>Teste <b>Teste Bold</b></Type.h1>

H2
<Type.h2>Teste <b>Teste Bold</b></Type.h2>

H3
<Type.h3>Teste <b>Teste Bold</b></Type.h3>

H4
<Type.h4>Teste <b>Teste Bold</b></Type.h4>

H5
<Type.h5>Teste <b>Teste Bold</b></Type.h5>

H6
<Type.h6>Teste <b>Teste Bold</b> <i>Teste Itálico</i> <i><b>Teste Itálico Bold</b></i></Type.h6>

P
<Type.p>Teste <b>Teste Bold</b> <i>Teste Itálico</i> <i><b>Teste Itálico Bold</b></i> <em>Teste EM</em></Type.p>

*/
